import { render, staticRenderFns } from "./PartnerRegisterNewIframe.vue?vue&type=template&id=57b79d68&"
import script from "./PartnerRegisterNewIframe.vue?vue&type=script&lang=ts&"
export * from "./PartnerRegisterNewIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports